<template>
	<div
		:class="
			cn(
				props.containerClass,
				'flex w-full gap-2 md:items-center md:justify-center'
			)
		"
	>
		<Button
			v-for="tab in tabs"
			:key="tab.id"
			:variant="tab.active ? 'primary' : 'secondary'"
			class="flex w-full select-none items-center gap-3 border-0 border-b-2 !border-transparent bg-none !px-0 pt-2 text-base !ring-0 md:py-2"
			:class="
				cn(
					props.class,
					tab.active
						? '!border-primary !bg-white text-primary'
						: 'border-white-dark-4 bg-white text-primary-light-4 hover:border-primary'
				)
			"
			@click="handleTabClick(tab.id)"
		>
			{{ tab.label }}
		</Button>
	</div>
</template>

<script setup lang="ts">
import { cn } from '@/utils';
import type { HTMLAttributes } from 'vue';
import type { NavigationTab, Tab } from '.';

const props = defineProps<{
	tabs: NavigationTab[];
	class?: HTMLAttributes['class'];
	containerClass?: HTMLAttributes['class'];
}>();

const activeTabId = defineModel<Tab | null>();

function handleTabClick(tabId: Tab) {
	activeTabId.value = tabId === activeTabId.value ? null : tabId;
}
</script>
